import { Injectable } from "@angular/core";
import { WebVoucherService } from "../../services/web_voucher.service";
import { WebVoucherBalanceViewModel } from "../../shared/models/web_voucher.model";
import { environment } from "../../../../environments/environment";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { UserWebvoucherViewModel, UserInfoData } from "../../shared/models/userInfo.model";
import DateManager from "../../shared/dateManager";
import * as moment from "moment";

@Injectable()
export class WebvoucherDetailService {

  constructor(private _webvoucherService: WebVoucherService
    , private _circularInjectionHelper: CircularInjectionHelper) {

  }

  public GetWebVoucherBalanceViewModelFromStorage(): Promise<WebVoucherBalanceViewModel> {
    const me = this;
    return new Promise<WebVoucherBalanceViewModel>((resolve, reject) => {
      me._webvoucherService.GetWebVoucherBalanceViewModelFromStorage()
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          me._circularInjectionHelper.coreLogService.error("WebvoucherDetailService.GetWebVoucherBalanceViewModelFromStorage", "GetWebVoucherBalanceViewModelFromStorage", e);
          reject();
        });
    });
  }

  public GetWebvoucherBalanceViewModel(): Promise<WebVoucherBalanceViewModel> {
    const me = this;
    return new Promise<WebVoucherBalanceViewModel>((resolve, reject) => {
      me._webvoucherService.GetWebVoucherBalanceViewModel()
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          me._circularInjectionHelper.coreLogService.error("WebvoucherDetailService.GetWebvoucherBalanceViewModel", "GetWebVoucherBalanceViewModel", e);
          reject();
        });
    });
  }

  public GetWebvoucherQRCode(): Promise<UserWebvoucherViewModel> {
    const me = this;
    return new Promise<UserWebvoucherViewModel>((resolve, reject) => {
      me._circularInjectionHelper.yourAppServer.User.GetUserInfo()
        .then((UserInfo) => {
          resolve(me.mapToUserWebvoucherViewModel(UserInfo));
        })
        .catch((error) => {
          me._circularInjectionHelper.coreLogService.error("WebvoucherDetailService.GetWebvoucherQRCode", "yourAppServer.User.GetUserInfo()", error);
          reject();
        });
    });
  }

  private mapToUserWebvoucherViewModel(model: UserInfoData): UserWebvoucherViewModel {
    if (model) {
      const viewModel = new UserWebvoucherViewModel();
      viewModel.webvoucherQRCode = model.card_qr_code_url;
      viewModel.webvoucherNumber = model.card_number;
      return viewModel;
    } else {
      return null;
    }
  }
}
